import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makeGuarantorsReqConfig = () => ({
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'guarantors',
  ],
});

const requestOptions = makeGuarantorsReqConfig();

export const consts = createReqConsts('guarantors');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/requests/guarantors-req.js